(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["culture-house-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('culture-house-mobile-navigation')) {
    class CultureHouseMobileNavigation extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('.culture-house-drawer__details');
        this.summary = this.querySelector('.culture-house-drawer__summary');
        this.panel = this.querySelector('.culture-house-drawer__panel');
        this.inertTargets = [...document.querySelectorAll('main, #footer-group')];
        this.previouslyInert = new Map();
        this.mediaQuery = window.matchMedia('(min-width: 990px)');
        this.handleToggle = this.handleToggle.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBreakpoint = this.handleBreakpoint.bind(this);
        this.details?.addEventListener('toggle', this.handleToggle);
        this.addEventListener('keydown', this.handleKeydown);
        this.mediaQuery.addEventListener('change', this.handleBreakpoint);
      }

      disconnectedCallback() {
        this.details?.removeEventListener('toggle', this.handleToggle);
        this.removeEventListener('keydown', this.handleKeydown);
        this.mediaQuery?.removeEventListener('change', this.handleBreakpoint);
        this.unlockPage();
      }

      handleToggle() {
        if (this.details?.open) {
          this.previousFocus = document.activeElement;
          this.lockPage();
          requestAnimationFrame(() => this.getFocusableElements()[1]?.focus());
        } else {
          this.unlockPage();
          if (this.contains(document.activeElement) || document.activeElement === document.body) {
            this.summary?.focus();
          }
        }
      }

      handleBreakpoint(event) {
        if (event.matches && this.details?.open) this.details.open = false;
      }

      handleKeydown(event) {
        if (!this.details?.open) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.details.open = false;
          return;
        }

        if (event.key !== 'Tab') return;
        const focusable = this.getFocusableElements();
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      getFocusableElements() {
        return [this.summary, ...this.panel.querySelectorAll('a[href], button:not([disabled]), summary')].filter(
          (element) => element && !element.closest('[hidden]') && element.getClientRects().length
        );
      }

      lockPage() {
        if (this.isLocked) return;
        this.isLocked = true;
        this.hadScrollLock = document.documentElement.hasAttribute('scroll-lock');
        document.documentElement.setAttribute('scroll-lock', '');
        this.inertTargets.forEach((target) => {
          this.previouslyInert.set(target, target.inert);
          target.inert = true;
        });
      }

      unlockPage() {
        if (!this.isLocked) return;
        this.isLocked = false;
        if (!this.hadScrollLock) document.documentElement.removeAttribute('scroll-lock');
        this.inertTargets?.forEach((target) => {
          target.inert = this.previouslyInert.get(target) || false;
        });
        this.previouslyInert?.clear();
      }
    }

    customElements.define('culture-house-mobile-navigation', CultureHouseMobileNavigation);
  }
  } catch(e) { console.error(e); }
})();

})();
